import { useOfferContext } from '../../../context';
import React from 'react';
import { ExtensionLabel } from '../../../components/ExtensionLabel';

export function GeoExtensionLabelContainer() {
  const { geoExtensionLabel } = useOfferContext();

  if (!geoExtensionLabel) {
    return null;
  }

  return <ExtensionLabel text={geoExtensionLabel} />;
}
